import apiURLBuilder from '../core/apiURLBuilder';
import Api from '../services/api';
import actionTypes from 'constants/actionTypes';
import preLoaderActions from 'actions/preLoaderActions';
import debitCardActions from 'actions/debitCardActions';
import Storage from 'utilities/storage';

import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
import { isPinNotRequired, getDebitCardPoeditorKey } from 'utilities/debitCard';
import { goToErrorsView } from 'actions/errorViewNavigation';

const getDebitCardService = dispatch => {
    const accessToken = Storage.cookies.get('accessToken');

    dispatch(preLoaderActions.showPreLoader());
    const debitCardInformationUrl = apiURLBuilder.getURL('debitCardsInformation');
    Api.get(debitCardInformationUrl, {
        header: {
            Authorization: `Bearer ${accessToken}`,
            originCountry: getReferenceCodeByCountry().toUpperCase(),
        },
    }).then(
        response => {
            if (response) {
                const cardList = response.body.filter(card => card.activated);
                if (cardList.length === 1 && isPinNotRequired()) {
                    return dispatch(debitCardActions.selectPinDebitCard(cardList[0]));
                }
                const cardListStandard = cardList
                    .map((card, index) => {
                        return {
                            id: index,
                            urlImage: card.urlCard,
                            standard: card.standard,
                            subtype: card.subtype,
                            type: card.type,
                            order: card.order ? card.order : index,
                            activated: card.activated,
                            poeditorKey: getDebitCardPoeditorKey(card.type, card.subtype, card.standard),
                        };
                    })
                    .sort((a, b) => {
                        return a.order - b.order;
                    });

                dispatch({
                    type: actionTypes.GET_DEBIT_CARDS,
                    data: cardListStandard,
                });
            } else {
                dispatch(goToErrorsView({ errorMessage: debitCardInformationUrl }));
            }
            dispatch(preLoaderActions.hidePreLoader());
        },
        error => {
            dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: debitCardInformationUrl }));
            dispatch(preLoaderActions.hidePreLoader());
        }
    );
};

const getDebitCards = () => {
    return dispatch => {
        getDebitCardService(dispatch);
    };
};

const getCreditCardImageService = (dispatch, saveRequestData) => {
    const getCMSContentUrl = apiURLBuilder.getURL('getCMSContent');
    Api.get(getCMSContentUrl, saveRequestData).then(response => {
        if (response.body.status === 'Error') {
            dispatch(goToErrorsView({ errorCode: response.status, errorMessage: getCMSContentUrl }));
        } else {
            const data = [
                {
                    id: 1,
                    url: response.body.data.nodes[0].field_image_large[0].url,
                    code: null,
                },
            ];

            dispatch({
                type: actionTypes.GET_CARD_IMAGES,
                data,
            });
        }
    });
};

// old

const getCardImagesService = (dispatch, saveRequestData) => {
    const getCardImagesUrl = apiURLBuilder.getURL('getCardImages');
    Api.get(getCardImagesUrl, saveRequestData).then(response => {
        if (response.body.status === 'Error') {
            dispatch(goToErrorsView({ errorCode: response.status, errorMessage: getCardImagesUrl }));
        } else {
            //const data = response.body || [];
            const data = [
                {
                    id: '1',
                    url: 'https://www.openbank.es/assets/2018-02/OpenCredit_Grande_480x300.png',
                    code: 'TARJETAOPENCREDIT',
                },
            ];

            dispatch({
                type: actionTypes.GET_CARD_IMAGES,
                data,
            });
        }
    });
};

const getCardImages = accessToken => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };

        getCardImagesService(dispatch, saveRequestData);
    };
};

const getCreditCardImageAction = () => {
    return dispatch => {
        const saveRequestData = {
            header: {},
            query: {
                channel: 'private',
                webContentId: 'B.500.801.012',
            },
        };
        getCreditCardImageService(dispatch, saveRequestData);
    };
};

export default {
    getCreditCardImageAction,
    getDebitCards,
    getCardImages,
};
